import React from "react";
import { Modal, ModalBody, ModalHeader, Button } from "reactstrap";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

const StripePaymentModal = ({
  isOpen,
  toggle,
  clientSecret,
  onPaymentSuccess,
}) => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async () => {
    if (!stripe || !elements) return;

    const cardElement = elements.getElement(CardElement);
    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardElement,
      },
    });

    if (result.error) {
      alert(result.error.message);
    } else if (result.paymentIntent.status === "succeeded") {
      onPaymentSuccess();
      toggle(); // close modal
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalBody className="bg-white" style={{ borderRadius: "20px" }}>
        <h5 className="mb-0 fw-semibold">Enter Card Details</h5>
        <div className="mb-3">
          <CardElement
            options={{
              style: {
                base: {
                  fontSize: "16px",
                  color: "#495057",
                  fontFamily: "inherit",
                  "::placeholder": {
                    color: "#adb5bd",
                  },
                },
                invalid: {
                  color: "#dc3545",
                },
              },
            }}
            className="form-control p-3 border rounded"
          />
        </div>

        <Button
          onClick={handleSubmit}
          color="primary"
          className="w-100 py-2 fw-semibold"
        >
          Pay Now
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default StripePaymentModal;
